import { render, staticRenderFns } from "./StudentQuestioning.vue?vue&type=template&id=039fc962"
import script from "./StudentQuestioning.vue?vue&type=script&lang=js"
export * from "./StudentQuestioning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports